import userRepository from './userRepository'
import transformationInputOneRepository from './transformationInputOneRepository'
import contactUsRepository from './contactUsRepository'
import PaymentsRepository from './paymentsRepository'
import AssessmentRepository from './assessmentRepository'

const repositories = {
  user: userRepository,
  transformation_input_one: transformationInputOneRepository,
  contactus: contactUsRepository,
  payments: PaymentsRepository,
  assesment: AssessmentRepository
  // other repositories ...
}

export const RepositoryFactory = {
  get: name => repositories[name]
}



// WEBPACK FOOTER //
// ./src/repositories/RepositoryFactory.js